
// ! rename the function to align with the widget name

export const customNavigation = () => {
    const el = document.querySelector('.curious-custom-navigation');
    if (!el) return;

    // ------------------------------------------------------------

    const bodyTag = document.querySelector('body');    

    const hamburger = el.querySelector('.hamburger')
    hamburger.addEventListener('click', () => {
        bodyTag.classList.toggle('nav-open')
        hamburger.classList.toggle('is-active')
    })

    const mq = window.matchMedia('(min-width: 986px)')
    mq.addEventListener('change', (e) => {
        if (e.matches) {
            bodyTag.classList.remove('nav-open')
            hamburger.classList.remove('is-active')
        }
    })

    document.getElementById('search-button').addEventListener('click', function(e) {
        console.log('Search button clicked');
        // Replace 'YOUR_POPUP_ID' with your actual popup ID
        //elementorFrontend.documentsManager.documents['#search-form'].showModal();
        elementorProFrontend.modules.popup.showPopup({ id: 374 });
    });
    
    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

